export enum FormValidationType {
    Required = 'Required',
    NumberOnly = 'NumberOnly',
    MaxLength = 'MaxLength',
}

export enum RunTime {
    OnBlur = 'OnBlur',
    OnKeyDown = 'OnKeyDown',
    OnChange = 'OnChange',
}

export enum KEY_CODES {
    digit0 = 48,
    digit9 = 57,
}

export interface Rule {
    type: FormValidationType;
    errorMessage: string;
    value?: string | number;
}

export interface CustomRule {
    runTime: RunTime[];
    regExp: RegExp;
    errorMessage: string;
}

export type Field = {
    rules?: Rule[];
    customRules?: CustomRule[];
    violatedRules: (Rule | CustomRule)[];
    value: string | boolean | null | undefined;
    isValid: boolean;
};

export type Form = {
    [filedName: string]: Field;
};
